import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconSecurityOff, IconSecurityOn } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleInDistress } from '../../../inklusiva/sessiondata/actions';
const styles = () => {
    return {
        pendingContainer: {
            position: 'absolute',
            bottom: '3px',
            right: '3px'
        }
    };
};
/**
 * Component that renders a toolbar button for toggling audio mute.
 *
 * @augments AbstractAudioMuteButton
 */
class DistressButton extends AbstractButton {
    /**
     * Initializes a new {@code AudioMuteButton} instance.
     *
     * @param {IProps} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.icon = IconSecurityOff;
        this.label = 'Notfall-Knopf';
        this.tooltip = 'toolbar.enterFullScreen';
        this.accessibilityLabel = 'toolbar.accessibilityLabel.enterFullScreen';
        this.toggledIcon = IconSecurityOn;
        this.toggledLabel = 'Notfall-Knopf aktiv';
        this.toggledTooltip = 'toolbar.exitFullScreen';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.exitFullScreen';
        // Bind event handlers so they are only bound once per instance.
        this._onKeyboardShortcut = this._onKeyboardShortcut.bind(this);
        this._getTooltip = this._getLabel;
    }
    /**
     * Registers the keyboard shortcut that toggles the audio muting.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        // this.props.dispatch(registerShortcut({
        //     character: 'M',
        //     helpDescription: 'keyboardShortcuts.mute',
        //     handler: this._onKeyboardShortcut
        // }));
    }
    /**
     * Unregisters the keyboard shortcut that toggles the audio muting.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        // this.props.dispatch(unregisterShortcut('M'));
    }
    /**
     * Handles clicking the button, and toggles fullscreen.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        this.props.dispatch(toggleInDistress());
    }
    /**
     * Indicates if audio is currently muted or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._inDistress;
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action to
     * toggle the audio muting.
     *
     * @private
     * @returns {void}
     */
    _onKeyboardShortcut() {
        // Ignore keyboard shortcuts if the audio button is disabled.
        if (this._isDisabled()) {
            return;
        }
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code AudioMuteButton} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _audioMuted: boolean,
 *     _disabled: boolean
 * }}
 */
function _mapStateToProps(state) {
    const inDistress = state['features/inklusiva/sessiondata']?.inDistress ?? false;
    return {
        _inDistress: inDistress
    };
}
export default withStyles(styles)(translate(connect(_mapStateToProps)(DistressButton)));
